module.exports = __webpack_public_path__ + "static/helix-3ab1f0c04de70377f778e366df7366a4.svg";